<template>
    <div class="learning_layout">
        <slot></slot>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.learning_layout{
    // padding: 30px;
    border-radius: 20px;
    overflow: hidden;
    background: #fff;
    min-height: 570px;
}
</style>